import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
const { colors } = constants;

const greyBorder = `1px solid ${colors.ui.neutral[100]}`;

export const sectionCss: CSSObject = {
  padding: "16px 24px",
  borderTop: greyBorder,
};

export const titleCss: CSSObject = {
  fontWeight: 700,
};

export const fullPageLinkCss: CSSObject = {
  display: "block",
  marginBottom: 16,
};

export const collapsibleSectionCss: CSSObject = {
  // Break out of the outer sectionCss horizontal padding so the border
  // spans the full panel width, matching the panel header dividers.
  margin: "0 -24px",
  borderTop: greyBorder,
};

export const sectionToggleButtonCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "16px 24px",
  fontWeight: 700,
  fontSize: 16,
  lineHeight: "24px",
  textAlign: "left",
  color: colors.ui.black[100],
};

export const chevronCss = (isOpen: boolean): CSSObject => ({
  width: 20,
  height: 20,
  flexShrink: 0,
  transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
  transition: "transform 180ms ease",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none",
  },
});

export const sectionBodyCss: CSSObject = {
  padding: "0 24px 16px",
};

export const standardItemCss: CSSObject = {
  paddingBottom: 12,
  marginBottom: 12,
  borderBottom: greyBorder,

  ":last-child": {
    borderBottom: "none",
    marginBottom: 0,
    paddingBottom: 0,
  },
};

export const standardCodeCss: CSSObject = {
  display: "block",
  fontWeight: 700,
  fontSize: 12,
  lineHeight: "16px",
  color: colors.ui.neutral[500],
  marginBottom: 4,
};

export const standardDescriptionCss: CSSObject = {
  margin: 0,
  fontSize: 14,
  lineHeight: "20px",
};

export const subheadingCss: CSSObject = {
  backgroundColor: colors.ui.blue[25],
  borderRadius: 8,
  padding: "8px 12px",
  fontWeight: 700,
  fontSize: 14,
  lineHeight: "20px",
  marginBottom: 8,
};
